import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  LoadingDialog,
} from "../../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import * as productActions from "../../../../Base/_redux/products/productsActions";
import * as orderActions from "../../../_redux/orders/ordersActions";
import { OrderProductCard } from "../order-product-card/OrderProductCard";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { Formik } from "formik";
import OrderFilterBox from "../../../../../../_metronic/layout/components/order-filter-box/OrderFilterBox";
import KTLayoutAsideToggle from "../../../../../../_metronic/_assets/js/layout/base/aside-toggle";

export function OrderProducts() {
  const {
    lastOrder,
    products,
    productsLoading,
    productCategories,
    selectedCategory,
    productSearchText,
  } = useSelector(
    (state) => ({
      lastOrder: state.orders.lastOrder,
      products: state.products.entities,
      productsLoading: state.products.listLoading,
      productCategories: state.products.categories,
      productSearchText: state.orders.productSearchText,
      selectedCategory: state.orders.selectedCategory,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(productActions.fetchCategories());
  }, [dispatch]);
  

  useEffect(() => {
    dispatch(
      productActions.fetchProducts({
        categoryId: selectedCategory,
        filter: { name: productSearchText },
      })
    );
  }, [selectedCategory, dispatch, productSearchText]);

  const onChangeCategory = (id) => {
    dispatch(orderActions.changeCategory(id));
  };

  const onSearchChange = (searchText) => {
    dispatch(orderActions.changeSearchText(searchText));
  };

  return (
    <div className={"row"}>
      <div className={"col-3"} style={{ overflowY: "scroll", height: "75vh" }}>
        <OrderFilterBox />
      </div>

      <div className="col-9" style={{ overflowY: "scroll", height: "75vh" }}>
        <Card>
          <CardHeader title={lastOrder.name}>
            <CardHeaderToolbar>
              {/*<Link to={"/sales/orders/cart"}*/}
              {/*      className={"btn btn-primary"}>*/}
              {/*    مشاهده کامل سفارش*/}
              {/*    <span className="svg-icon svg-icon-white svg-icon-2x">*/}
              {/*        <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")}/>*/}
              {/*    </span>*/}
              {/*</Link>*/}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {productsLoading && (
              <LoadingDialog
                isLoading={true}
                text={"در حال بارگذاری محصولات ..."}
              />
            )}
            <Formik
              initialValues={{ searchText: "" }}
              onSubmit={(values) => onSearchChange(values.searchText)}
            >
              {({ values, handleSubmit, handleBlur, setFieldValue }) => (
                <form
                  onSubmit={handleSubmit}
                  className={"form form-label-right"}
                >
                  <div className={"form-group row"}>
                    <div className={"col-lg-4"}>
                      <input
                        type={"text"}
                        className={"form-control"}
                        name={"searchText"}
                        placeholder={"جستجو در محصولات"}
                        onBlur={handleBlur}
                        value={values.searchText}
                        onChange={(e) => {
                          setFieldValue("searchText", e.target.value);
                          handleSubmit();
                        }}
                      />
                      <small className={"form-text text-muted"}>
                        <b>جستجو</b> در محصولات
                      </small>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
            {/* {!productsLoading && (
          <div className="row mb-4 bg-primary py-5">
            {productCategories &&
              productCategories.map((categ) => (
                <div key={categ.physicalId} className={"col-4"}>
                  <button
                    type={"button"}
                    onClick={() => onChangeCategory(categ.physicalId)}
                    className={"btn btn-outline-white w-100"}
                  >
                    {selectedCategory === categ.physicalId && (
                      <span className="svg-icon svg-icon-md svg-icon-white">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Code/Done-circle.svg"
                          )}
                        />
                      </span>
                    )}
                    {categ.name}
                  </button>
                </div>
              ))}
          </div>
        )} */}

            <hr />
            <div>
              {!productsLoading && (
                <div
                  className="d-flex justify-content-start align-items-stretch flex-wrap w-100"
                  // style={{ overflowY: "scroll", height: "55vh" }}
                >
                  {products &&
                    products.map((product) => (
                      <div key={product.id} className="w-250px mr-4 mb-4">
                        <OrderProductCard product={product} />
                      </div>
                    ))}
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
